module.exports = __webpack_public_path__ + "static/rp-960189d7589c43204b8634d544d26bd7.png";